import { render, staticRenderFns } from "./culture.vue?vue&type=template&id=5a9f1225"
import script from "./culture.vue?vue&type=script&lang=js"
export * from "./culture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotLoaderPage: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/LoaderPage/LoaderPage.vue').default,HotCulture: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Templates/Culture/Culture.vue').default})
